import { nodeToInputNames } from '../../../../../../../../../../store/helpers/titleToSectionKeyDict';
import expertTipsDict from './expertTipsDict';

const chipIntro = (params) => {
  const { editorRef, sectionKey, showExpertTips, setExpertTips } = params;

  if (!editorRef || !editorRef.value || !editorRef.value.focusBlock) return;

  if (!expertTipsDict[sectionKey]) return;

  const {
    value: { focusBlock },
  } = editorRef;

  const { type: focusBlockType, key: focusBlockKey } = focusBlock;

  let activeChip;
  if (
    expertTipsDict[sectionKey][focusBlockType] &&
    expertTipsDict[sectionKey][focusBlockType].type === 'single_node'
  ) {
    activeChip = expertTipsDict[sectionKey][focusBlockType].tab;
  } else if (focusBlockType === 'paragraph') {
    /**
     * Role description & achievements
     */
    const parent = editorRef.value.document.getParent(focusBlockKey);

    if (parent.type === 'list_item') {
      const grandParent = editorRef.value.document.getParent(parent.key);

      if (grandParent.type === 'unordered_list') {
        const grandGrandParent = editorRef.value.document.getParent(
          grandParent.key,
        );
        const isDescription = grandGrandParent.type.includes('description');
        const isAchievement = grandGrandParent.type.includes('achievements');
        if (isDescription || isAchievement) {
          activeChip = nodeToInputNames[grandGrandParent.type];
        }
      }
    }
  }

  if (showExpertTips && activeChip) {
    setExpertTips({ activeChip });
  }
};

export default chipIntro;
